/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WidgetExclusions
 */
export interface WidgetExclusions {
    /**
     * 
     * @type {Array<string>}
     * @memberof WidgetExclusions
     */
    excludedCaseIds?: Array<string>;
}

/**
 * Check if a given object implements the WidgetExclusions interface.
 */
export function instanceOfWidgetExclusions(value: object): value is WidgetExclusions {
    return true;
}

export function WidgetExclusionsFromJSON(json: any): WidgetExclusions {
    return WidgetExclusionsFromJSONTyped(json, false);
}

export function WidgetExclusionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetExclusions {
    if (json == null) {
        return json;
    }
    return {
        
        'excludedCaseIds': json['excludedCaseIds'] == null ? undefined : json['excludedCaseIds'],
    };
}

export function WidgetExclusionsToJSON(json: any): WidgetExclusions {
    return WidgetExclusionsToJSONTyped(json, false);
}

export function WidgetExclusionsToJSONTyped(value?: WidgetExclusions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'excludedCaseIds': value['excludedCaseIds'],
    };
}

